import {logEvent} from "firebase/analytics";
import {firebaseAnalytics} from "../../../firebaseConfig";

export type WSErrorHandler = (error: string) => void;
export type WSTranscriptHandler = (text: string, isFinal: boolean) => void;

export type SocketDataType = string | ArrayBufferLike | Blob | ArrayBufferView

export abstract class WS {
    abstract createConnection(): Promise<void>;

    constructor(
        public errorHandler: WSErrorHandler,
        public transcriptHandler: WSTranscriptHandler,
        public readonly name: string = 'Undefined',
        private startSound: HTMLAudioElement = new Audio("/sounds/start.mp3"),
        private stopSound: HTMLAudioElement = new Audio("/sounds/stop.mp3"),
        protected socket: WebSocket | null = null,
        private connected: boolean = false
    ) {
    }

    async connect() {
        await this.close()
        await this.createConnection()
        await this.startSound?.play()

        logEvent(firebaseAnalytics, "ws_connect", {ws_name: this.name})

        this.connected = true
    }

    send(data: SocketDataType): void {
        if (this.socket?.readyState === WebSocket.OPEN) {
            try {
                this.socket.send(data);
            } catch (e) {
                console.error(`[WS] failed to send chunk:`, e);
            }
        }
    }

    async close() {
        if (!this.socket) return;

        this.socket.close();
        this.socket = null;
        console.info(`[WS] stopped`);
        await this.stopSound?.play()
    }

    protected handleError(error: string) {
        if (!this.connected) return;

        console.warn('[WS]', error)
        this.errorHandler(error);
    }

    protected handleTranscript(text: string, isFinal: boolean) {
        console.info('[WS] transcript:', text)
        this.transcriptHandler(text, isFinal);
    }
}
